export default __webpack_public_path__ + "static/dessert display-bd954dc4c5fa318199bc10a7e5f9fd72.svg";